var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isHeaderFooter)?_c('div',{attrs:{"id":"nav"}},[_c('top-header'),_c('whats-app')],1):_vm._e(),_c('router-view'),(!_vm.isHeaderFooter)?_c('bottom-footer'):_vm._e(),_c('global-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }